import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom"; //React routes//Necesario para uso de redux//GifLoa
import {
  Typography,
  Paper,
  Tabs,
  Tab as TabCustom,
  Box,
  styled,
  useTheme,
} from "@mui/material";
import PropTypes from "prop-types";
import Parser from "html-react-parser";
import moment from "moment";
import {
  Controller,
  useForm,
  useFormContext,
  FormProvider,
} from "react-hook-form";
import ReCAPTCHA from "react-google-recaptcha";

import packageJson from "../../../package.json";
import { coreFunctions, obtenerDireccionIP } from "../../utils";
import {
  productActions,
  validationActions,
  fileActions,
  authActions,
  workflowActions,
} from "../../store/actions"; //Acciones para redux
import {
  Alert,
  CustomAlertHelpDialog,
  CustomLoadingOverlay,
  Buttons,
  InputField,
  SelectLanguage,
} from "../../components";
// import { mainStyles, theme } from '../../styles'
import { useStyles } from "./RegisterStyles";
import { registerFunctions } from "./RegisterFunctions";
import { getReplaceTitle } from "../../utils";
import { getHash, ClearSession, IPDEFAULT } from "../../utils";
import RegisterImageImg from "../../assets/RegisterImage.jpg";
import { useTranslation } from "react-i18next";
import LanguageIcon from "@mui/icons-material/Language";

const OutletWrapperContent = styled(Box)(({ theme }) => ({
  background: "#FFFFFF",
  margin: "0px",
  marginBottom: "0px",
  minHeight: "calc(100vh - 38px)",
  overflowY: "auto !important",
  height: "90vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  overflowX: "hidden !important",
  [theme.breakpoints.only("xs")]: {
    padding: "3px 0.5em",
  },
  [theme.breakpoints.only("sm")]: {
    padding: "3px 0.5em",
  },
  [theme.breakpoints.only("md")]: {
    padding: "5px 6em",
  },
  [theme.breakpoints.only("lg")]: {
    padding: "6px 5em",
  },
  [theme.breakpoints.only("xl")]: {
    padding: "8px 10em",
  },
}));

const Tab = styled(TabCustom)(({ theme }) => ({
  width: "50% !important",
  maxWidth: "100% !important",
  fontWeight: "bold",
  letterSpacing: "0.15px",
  outline: "none",
  color: `${theme.palette.tab.text} !important`,
  [theme.breakpoints.only("xs")]: {
    width: "50% !important",
    outline: "none",
  },
  [theme.breakpoints.only("sm")]: {
    width: "50% !important",
    outline: "none",
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value != index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default function RegisterComponent(props) {
  const formMethods = useForm();
  const { useState, useEffect } = React; //Hook para el state
  const localStyles = useStyles(); //estílos de este componente (LoginStyles.js)
  const theme = useTheme();

  const { control, handleSubmit, watch, setValue, formState, register } =
    useForm({ mode: "onBlur" });

  const navigate = useNavigate(); //Módulo "History" de react router
  // const [state, setState] = useState({ taxRegimeField: '', userNameField: '', passwordField: '', passwordField1: '', nameField: '', fatherLastNameField: '', motherLastNameField: '', emailField: '', phoneNumberField: '', areCustomField: '', rcCaptcha: '', avisoPrivacidadChecked: false });
  const [loadView, setLoadView] = useState(false); //Se muestra/oculta el gif loader
  const [activaEnvioDatos, setActivaEnvioDatos] = useState(false);
  const [valueTab, setValueTab] = useState(0);
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [formChange, setFormChange] = useState(false);
  const [activeButton, setActiveButton] = useState(false);
  // const { taxRegimeField, userNameField, passwordField, passwordField1, nameField, fatherLastNameField, motherLastNameField, emailField, phoneNumberField, areCustomField, rcCaptcha, avisoPrivacidadChecked } = state;
  const [ctrlsDefinitions, setCtrlsDefinitions] = useState([]);
  const [loadProduct, setLoadProduct] = useState(false);

  //Estados de componente
  const [activeProduct, setActiveProduct] = useState(false);
  const [sendCAPTCHA, setSendCAPTCHA] = useState(false);

  const [nextStage, setNextStage] = useState(null);
  const [folioId, setFolioId] = useState(null);
  const [nextLego, setNextLego] = useState(null);
  const [nextContinueLego, setNextContinueLego] = useState(null);
  const [activeNextLego, setActiveNextLego] = useState(null);

  const [ipCurrent, setIpCurrent] = useState("");

  ////reduxer hooks : Inicio
  const prodRemote = useSelector((state) => state.ProductRemote);
  const remoteCode = useSelector((state) => state.FolioRemote);
  const validaCAPTCHA = useSelector((state) => state.VALCAPTCHA);
  const auth = useSelector((state) => state.Authentication);
  const wf = useSelector((state) => state.Workflow);
  const file = useSelector((state) => state.FileInfo);
  const continueWF = useSelector((state) => state.ContinueWorkflow);

  const dispatch = useDispatch();
  const { i18n, t } = useTranslation();
  const productId = prodRemote?.productId;
  const isBrasilEnvironment = process.env.REACT_APP_ENVIRONMENT === "BRADEV" || process.env.REACT_APP_ENVIRONMENT === "BRA"


  useEffect(() => {
    //ComponentDidUpdate
    //Se comento para que no aparezca el simulador de credito al iniciar registro.
    // console.log('Prod items: ', location.state)
    // if (location.state?.isRegister === undefined
    //   || location.state?.isRegister === null
    //   || location.state?.isRegister == false) {
    //   navigate('/CreditSimulatorComponent')
    // }
    // else if (!activeProduct) {
    getReplaceTitle("Regístrate y solicita tu crédito");
    dispatch(productActions.ProductsRemote());
    setActiveProduct(true);
    setCtrlsDefinitions([]);
    setLoadProduct(true);
    obtenerDireccionIP((ip) => {
      setIpCurrent(ip);
      console.log("Dirección IP:", ip);
    });
    changeLanguage();
    // }
  }, []); //Valor a evaluar, sí este cambia, el contenido del arrow se ejecutará

  const changeLanguage = () => {
    const savedLanguage = sessionStorage.getItem("lang");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  };

  useEffect(() => {
    setLoadView(prodRemote.loading);
    // console.log('prodRemote: ', prodRemote)
    if (
      prodRemote.items != undefined &&
      prodRemote.items != null &&
      loadProduct
    ) {
      // console.log('Prod items: ', prodRemote.items)
      if (prodRemote.items.length > 0) {
        console.log("Procto definicion:***************** ", prodRemote);
        setCtrlsDefinitions(prodRemote.controls);
        setLoadProduct(false);
      }
    } else if (
      prodRemote.error != undefined &&
      prodRemote.error != null &&
      loadProduct
    ) {
      Alert({
        icon: "error",
        text: prodRemote.error,
        okbtntext: t("general_accept"),
      });
    }
  }, [prodRemote]);

  useEffect(() => {
    setLoadView(remoteCode.loading);
    if (
      remoteCode.items != undefined &&
      remoteCode.items != null &&
      activaEnvioDatos
    ) {
      console.log("remoteCode.items*******************: ", remoteCode.items);
      if (
        remoteCode.items?.Stage != undefined &&
        remoteCode.items?.Stage != null &&
        activeNextLego
      ) {
        let data = {
          //Objeto a enviar a API login
          RequestDataInfo: {
            IP: ipCurrent ?? IPDEFAULT,
            MacAddress: "FC:01:7C:45:48:3F",
          },
          Tenant: "",
          Username: user,
          PasswordHash: getHash(pass),
        };
        dispatch(authActions.Authentication(data));
        setNextStage(remoteCode.items.Stage);
        setFolioId(remoteCode.items.Stage?.File?.Id);
        setNextLego(true);
      } else {
        navigate("/auth/ConfirmComponent");
      }
    } else if (remoteCode.error != undefined && activaEnvioDatos) {
      Alert({
        icon: "error",
        text: remoteCode.error,
        okbtntext: t("general_accept"),
      });
    }
  }, [remoteCode]);

  useEffect(() => {
    if (
      validaCAPTCHA.items != undefined &&
      validaCAPTCHA.items != null &&
      sendCAPTCHA
    ) {
      setActiveButton(true);
    } else if (
      validaCAPTCHA.error != undefined &&
      validaCAPTCHA.error != null &&
      sendCAPTCHA
    ) {
      setActiveButton(false);
    }
  }, [validaCAPTCHA]);

  let handleChangeCaptcha = (event) => {
    console.log("handleChangeCaptcha: ", event);
    setSendCAPTCHA(true);
    dispatch(validationActions.ValidateCAPTCHA(event));
  };

  let submitRegister = (formData) => {
    if (productId <= 0) {
      Alert({
        icon: "error",
        text: "No se encontro un producto activo.",
        okbtntext: t("general_accept"),
      });
      return;
    }
    // if (!activeButton) {
    //   alert('Debes seleccionar el CAPTCHA.')
    //   return;
    // }

    let metadataRegistro = [];
    let metadataSolicitud = [];

    ctrlsDefinitions.forEach((itemValue) => {
      if (
        /* (itemValue.Label != "Nombre(s)" && itemValue.Label != "Apellido paterno"
        && itemValue.Label != "Apellido materno"
        && itemValue.Label != "Teléfono"
        && itemValue.Label != "Usuario"
        && itemValue.Label != "Correo electrónico"
        && itemValue.Label != "Contraseña"
        && itemValue.Label != "Repetir contraseña") &&  */ formData[
          `${itemValue.Name.replace(".", "")}`
        ] != undefined &&
        formData[`${itemValue.Name.replace(".", "")}`] != null
      ) {
        metadataRegistro.push({
          Name: itemValue.Label,
          Value: formData[`${itemValue.Name.replace(".", "")}`],
          GroupName: itemValue.QuestionGroup,
        });
        metadataSolicitud.push({
          Name: itemValue.Label,
          Value: formData[`${itemValue.Name.replace(".", "")}`],
          GroupName: itemValue.QuestionGroup,
        });
      }
    });

    let userNameField = formData["Usuario"];
    let passwordField = formData["Contraseña"];
    let passwordField1 = formData["Repetir contraseña"];

    setUser(userNameField);
    setPass(passwordField);

    if (passwordField?.trim() != passwordField1?.trim()) {
      Alert({
        icon: "error",
        text: "Las contraseñas no coninciden",
        okbtntext: t("general_accept"),
      });
      return;
    }

    let dataRequest = {
      //Objeto a enviar a API login
      NewUserData: {
        Tenant: "",
        UserName: userNameField,
        Password: passwordField,
        Name: formData["Nombre(s)"],
        FatherLastName: formData["Apellido paterno"],
        MotherLastName: formData["Apellido materno"],
        Email: formData["Correo electrónico"],
        PhoneNumber: formData["Teléfono"],
        Metadata: metadataRegistro,
      },
      ProductId: productId,
      Metadata: metadataSolicitud,
    };
    setActivaEnvioDatos(true);
    setActiveNextLego(false);
    dispatch(fileActions.GenerateFolioRemote(dataRequest));
  };

  let handleChangeTabs = (event, newValue) => {
    // console.log('Seleccion tabs: ', newValue)
    setValueTab(newValue);
  };

  ///********************************************************************* */
  //Acciones y eventos correspondientes al login.
  ///********************************************************************* */

  let submitLogin = (data) => {
    //Login
    // console.log("Data login: ", data)

    let request = {
      //Objeto a enviar a API login
      RequestDataInfo: {
        IP: ipCurrent ?? IPDEFAULT,
        MacAddress: "FC:01:7C:45:48:3F",
      },
      Tenant: "",
      Username: data["txtUser"],
      PasswordHash: getHash(data["txtPassword"]),
    };
    console.log("Data request Login: ", request);
    dispatch(authActions.Authentication(request));
    setFormChange(true);
    setLoadView(true);
  };

  useEffect(() => {
    // sessionStorage.clear()
    ClearSession();
    let wfData = {
      Workflow_Id: 0,
      Workflow_Version: 0,
      Apk_Version: "1.1.3",
      IMEI: "PWA",
    };
    if (auth.items != undefined && formChange) {
      sessionStorage.setItem("token", auth.items.Token);
      sessionStorage.setItem(
        "userName",
        `${auth.items.UserLoginData.Name} ${
          auth.items.UserLoginData.FatherLastName ||
          auth.items.UserLoginData.MotherLastName
        }`
      );
      dispatch(workflowActions.GetWorkflowDefinitions(wfData));
    } else if (auth.items != undefined && nextLego) {
      sessionStorage.setItem("token", auth.items.Token);
      sessionStorage.setItem(
        "userName",
        `${auth.items.UserLoginData.Name} ${
          auth.items.UserLoginData.FatherLastName ||
          auth.items.UserLoginData.MotherLastName
        }`
      );
      // if (remoteCode.items?.Stage?.Name == "") {
      setFolioId(remoteCode.items.Stage?.File?.Id);
      let request = {
        File_Id: remoteCode.items.Result?.Id,
      };
      console.log("resquest continue wof: ", request);
      setNextContinueLego(true);
      setNextLego(false);
      dispatch(workflowActions.ContinueWorkflowAction(request));
      // } else {
      //   setNextLego(false)
      //   let nextStage = remoteCode.items.Stage
      //   let stageName = nextStage.Name
      //   let stageId = nextStage.Id
      //   let stage = remoteCode.items
      //   let folioId = remoteCode.items.Stage?.File?.Id
      //   let activeNextLego = true
      //   // console.log('nextStage', stageName)
      //   let nextComponent = coreFunctions.GetLegoNext(stageName)
      //   registerFunctions.doNextStage({ auth ,navigate,nextComponent, stageName, stageId, stage, folioId, activeNextLego })
      // }
    }
  }, [auth.items]); //Valor a evaluar, sí este cambia, el contenido del arrow se ejecutará

  useEffect(() => {
    if (auth.error != undefined && formChange) {
      setLoadView(false);
      Alert({
        icon: "error",
        text: auth.error,
        okbtntext: t("general_accept"),
      });
    }
  }, [auth.error]);

  useEffect(() => {
    if (wf?.items != undefined && auth.items != undefined && formChange) {
      console.log(
        "Definicion de workflow***************************: ",
        wf?.items
      );
      dispatch(fileActions.GetFileInfo(auth.items.UserLoginData.CurrentFileId));
    }
  }, [wf.items]);

  useEffect(() => {
    if (file.items != undefined && formChange) {
      //Enviar a siguiente componente definido en el nucleo
      setLoadView(false);
      let nextStage = file.items.Stage;
      let stageName = nextStage.Name;
      let stageId = nextStage.Id;
      let stage = file.items;
      // console.log('nextStage', stageName)
      let nextComponent = coreFunctions.GetLegoNext(stageName);
      coreFunctions.DoNextStage({
        navigate,
        nextComponent,
        State: { stageName, stageId, stage },
      });
    }
  }, [file]);

  useEffect(() => {
    if (
      continueWF.items != undefined &&
      continueWF.items != null &&
      nextContinueLego
    ) {
      console.log(
        "continueWF.items***************************: ",
        continueWF.items
      );
      let nextStage = continueWF.items.Stage;
      let stageName = nextStage.Name;
      let stageId = nextStage.Id;
      let stage = continueWF.items;
      let activeNextLego = true;
      console.log("nextStage*****Aqui se cambia*****; ", stageName);
      let nextComponent = coreFunctions.GetLegoNext(stageName);
      setNextContinueLego(false);
      if (stageName == "Notificación") {
        navigate("/auth/ConfirmFinalizeComponent");
      } else {
        coreFunctions.DoNextStage({
          navigate,
          nextComponent,
          State: { stageName, stageId, stage, folioId, activeNextLego },
        });
      }
    } else if (
      continueWF.error != undefined &&
      continueWF.error != null &&
      nextContinueLego
    ) {
      setNextContinueLego(false);
      console.log("continueWF.error:********: ", continueWF.error);
    }
  }, [continueWF.items]);

  const handleSimulatorCalculate = () => {
    navigate("/auth/CreditSimulatorComponent");
  };

  return (
    <OutletWrapperContent>
      <FormProvider {...formMethods}>
        {loadView ? (
          <CustomLoadingOverlay
            active={loadView}
            text={t("general_loading_message")}
          />
        ) : null}
        <Box display='flex' justifyContent='space-between' alignItems='center' sx={{width: '100%'}} >
          <Typography variant="h6" gutterBottom color="primary">
          {t("registere_title")}
          </Typography>
          <Box sx={{
              display: 'flex',
              alignItems: 'center',
              right: '2rem',
              top: '2rem',
              position: 'absolute',
              width: '15%',
            }}>
              {!isBrasilEnvironment ? <SelectLanguage /> : null}
            </Box>
        </Box>

        <Typography variant="subtitle1" gutterBottom>
          {t("register_welcome_message")}
        </Typography>
        <Typography variant="h6" gutterBottom>
          {t("register_personal_data")}
        </Typography>
        {ctrlsDefinitions.length > 0 ? (
          <DynamicQuestion
            data={ctrlsDefinitions}
            clickSubmitCAPTCHA={handleChangeCaptcha}
            clickSubmit={submitRegister}
            activeButton={activeButton}
          />
        ) : null}
        <Typography
          variant="subtitle1"
          gutterBottom
          className={localStyles.tittleCopyright}
        >
          {packageJson.copyright}
        </Typography>

        {/* <UseImage src={RegisterImageImg} /> */}
        {/* <UseImage src={valueTab == 1 ? RegisterImageImg : RegisterImageImg} /> */}
        {/* <Paper sx={{ marginTop: '15px !important', backgroundColor: '#F2F2F2 !important', width: "70%" }} >
        <Tabs centered value={valueTab} indicatorColor="primary"
          textColor="primary" onChange={handleChangeTabs} aria-label="Tabs Register" >
          <Tab label="Registrarme" />
          <Tab label="Soy cliente" />
        </Tabs>
      </Paper>
      <TabPanel value={valueTab} index={0}>
        <Typography variant="h6" gutterBottom >Regístrate y adquiere tu póliza de seguro.</Typography>
        <Typography variant="subtitle1" gutterBottom >{Parser(`- Lee nuestro <a style='color:${theme.palette.primary.main}' href='https://docsolutions.com/es-aviso-de-privacidad/'>Aviso de Privacidad</a> y <a style='color:${theme.palette.primary.main}' href='https://docsolutions.com/politica-de-proteccion-de-datos/'>Protección de datos</a>. </br> - Llena el siguiente formulario con la información solicitada.`)}</Typography>
        <Typography variant="h6" gutterBottom >Datos personales</Typography>
        {ctrlsDefinitions.length > 0 ?
          <DynamicQuestion data={ctrlsDefinitions}
            clickSubmitCAPTCHA={handleChangeCaptcha}
            clickSubmit={submitRegister}
          />
          : null}
      </TabPanel>
      <TabPanel value={valueTab} index={1}>
        <Typography variant="h6" gutterBottom >Iniciar sesión</Typography>
        <InputField
          inputType="text"
          control={control}
          register={register}
          name='txtUser'
          label='Usuario'
          validations={{ required: true }}
          required={true}
          error={!!formState.errors['txtUser']}
          helperText={formState.errors['txtUser']?.message}
        />
        <InputField
          isPassword={true}
          control={control}
          register={register}
          name='txtPassword'
          label='Contraseña'
          validations={{ required: true }}
          required={true}
          error={!!formState.errors['txtPassword']}
          helperText={formState.errors['txtPassword']?.message}
        />
        <LinkButton LinkButtonText="Recuperar contraseña" LinkButtonUrl="/auth/PasswordRecoveryComponent" />
        <Buttons ConfirmButtonText="Iniciar sesión" onClickConfirm={handleSubmit(submitLogin)} />
      </TabPanel> */}
      </FormProvider>
    </OutletWrapperContent>
  );
}

const DynamicQuestion = (props) => {
  const localStyles = useStyles();
  const {
    control,
    handleSubmit,
    watch,
    formState,
    register,
    setError,
    setValue,
  } = useForm({ mode: "onBlur" });

  const [activePersonMoral, setActivePersonMoral] = useState(false);
  const watchRegimenFiscal = watch("¿Qué tipo de régimen fiscal tienes?");

  const passwordField = watch("Contraseña");
  const passwordField1 = watch("Repetir contraseña");

  useEffect(() => {
    console.log(
      "passwordField,passwordField : ",
      passwordField,
      passwordField1
    );
    if (
      passwordField?.trim() != passwordField1?.trim() &&
      passwordField1?.trim() !== ""
    ) {
      setError("Repetir contraseña", {
        message: "No coinciden las contraseñas",
      });
    }
  }, [passwordField, passwordField1]);

  useEffect(() => {
    // console.log("watchRegimenFiscal: ", watchRegimenFiscal)
    if (watchRegimenFiscal == "Persona física") {
      setActivePersonMoral(false);
    } else if (
      watchRegimenFiscal == "Persona física con actividad empresarial"
    ) {
      setActivePersonMoral(true);
    } else if (watchRegimenFiscal == "Persona moral") {
      setActivePersonMoral(true);
    }
  }, [watchRegimenFiscal]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
      {props.data.length > 0 &&
        props.data.map((itemInput, indexInput) => {
          // console.log("formState.errors: ", formState.errors[`${itemInput.Name}`])
          // console.log("itemInput:", activePersonMoral, itemInput)
          switch (itemInput.QuestionType.toUpperCase()) {
            case "PHONE":
              return (
                <InputField
                  inputType="phone"
                  control={control}
                  register={register}
                  name={`${itemInput.Name}`}
                  label={itemInput.Name}
                  validations={{ required: itemInput.Required }}
                  error={!!formState.errors[`${itemInput.Name}`]}
                  helperText={formState.errors[`${itemInput.Name}`]?.message}
                  required={itemInput.Required}
                />
              );
            case "NUMBER":
              return (
                <InputField
                  inputType="number"
                  control={control}
                  register={register}
                  name={`${itemInput.Name}`}
                  label={itemInput.Name}
                  validations={{ required: itemInput.Required }}
                  error={!!formState.errors[`${itemInput.Name}`]}
                  helperText={formState.errors[`${itemInput.Name}`]?.message}
                  required={itemInput.Required}
                />
              );
            case "CLABE":
              return (
                <InputField
                  inputType="clabe"
                  control={control}
                  register={register}
                  name={`${itemInput.Name}`}
                  label={itemInput.Name}
                  validations={{ required: itemInput.Required }}
                  error={!!formState.errors[`${itemInput.Name}`]}
                  helperText={formState.errors[`${itemInput.Name}`]?.message}
                  required={itemInput.Required}
                />
              );
            case "EMAIL":
              return (
                <InputField
                  inputType="email"
                  control={control}
                  register={register}
                  name={`${itemInput.Name}`}
                  label={itemInput.Name}
                  validations={{ required: itemInput.Required }}
                  error={!!formState.errors[`${itemInput.Name}`]}
                  helperText={formState.errors[`${itemInput.Name}`]?.message}
                  required={itemInput.Required}
                />
              );
            case "RADIO":
              return (
                <InputField
                  inputType="radio"
                  control={control}
                  register={register}
                  name={`${itemInput.Name}`}
                  label={itemInput.Name}
                  radioValues={itemInput.Options}
                  required={itemInput.Required}
                  validations={{ required: true }}
                  error={!!formState.errors[`${itemInput.Name}`]}
                  helperText={formState.errors[`${itemInput.Name}`]?.message}
                  onSelect={(e, value) => {
                    console.log(
                      "RADIO Value: ",
                      value,
                      " itemInput.Id : ",
                      itemInput.Id,
                      e
                    );
                    setValue(`${itemInput.Name}`, value);
                  }}
                />
              );
            case "COMBO":
              return (
                <InputField
                  inputType="select"
                  control={control}
                  register={register}
                  name={`${itemInput.Name}`}
                  label={itemInput.Name}
                  optionsList={itemInput.Options}
                  validations={{ required: itemInput.Required }}
                  error={!!formState.errors[`${itemInput.Name}`]}
                  helperText={formState.errors[`${itemInput.Name}`]?.message}
                  required={itemInput.Required}
                />
              );
            case "FECHA":
              return (
                <InputField
                  inputType="date"
                  control={control}
                  register={register}
                  name={`${itemInput.Name}`}
                  label={itemInput.Name}
                  validations={{ required: itemInput.Required }}
                  error={!!formState.errors[`${itemInput.Name}`]}
                  helperText={formState.errors[`${itemInput.Name}`]?.message}
                  required={itemInput.Required}
                />
              );
            case "CURRENCY":
              return (
                <InputField
                  inputType="currency"
                  control={control}
                  register={register}
                  name={`${itemInput.Name}`}
                  label={itemInput.Name}
                  validations={{ required: itemInput.Required }}
                  error={!!formState.errors[`${itemInput.Name}`]}
                  helperText={formState.errors[`${itemInput.Name}`]?.message}
                  required={itemInput.Required}
                />
              );
            case "PASSWORD":
              return (
                <InputField
                  inputType="password"
                  isPassword={true}
                  control={control}
                  register={register}
                  name={`${itemInput.Name}`}
                  label={itemInput.Name}
                  // validations={{ required: itemInput.Required }}
                  error={!!formState.errors[`${itemInput.Name}`]}
                  helperText={formState.errors[`${itemInput.Name}`]?.message}
                  required={itemInput.Required}
                />
              );
            case "CHECKBOX":
              return (
                <InputField
                  inputType="check"
                  control={control}
                  name={`${itemInput.Name}`}
                  label={itemInput.Label}
                  radioValues={itemInput.Options}
                  required={itemInput.Required}
                  validations={{ required: true }}
                  error={!!formState.errors[`${itemInput.Name}`]}
                  helperText={formState.errors[`${itemInput.Name}`]?.message}
                />
              );
            case "CAPTCHA":
              return null;
            default:
              return (
                <>
                  {/* {(itemInput.Name == "Denominación o razón social" || itemInput.Name == "RFC con homoclave") && !activePersonMoral ? null
              : itemInput.Name == "Denominación o razón social" && activePersonMoral ? <>
                <Typography variant="subtitle1" gutterBottom className={localStyles.titleSub}>Datos generales de la empresa / negocio</Typography>
                <InputField
                  inputType="text"
                  control={control}
                  register={register}
                  name={`${itemInput.Name}`}
                  label={itemInput.Name}
                  validations={{ required: itemInput.Required }}
                  defaultValue={itemInput.Value}
                  error={!!formState.errors[`${itemInput.Name}`]}
                  helperText={formState.errors[`${itemInput.Name}`]?.message}
                  required={itemInput.Required}
                />
              </> : itemInput.Name == "RFC con homoclave" && activePersonMoral ?
                < InputField
                  inputType="text"
                  control={control}
                  register={register}
                  name={`${itemInput.Name}`}
                  label={itemInput.Name}
                  validations={{ required: itemInput.Required }}
                  defaultValue={itemInput.Value}
                  error={!!formState.errors[`${itemInput.Name}`]}
                  helperText={formState.errors[`${itemInput.Name}`]?.message}
                  required={itemInput.Required}
                />
                :  */}
                  <InputField
                    inputType="text"
                    control={control}
                    register={register}
                    name={`${itemInput.Name}`}
                    label={itemInput.Name}
                    validations={{ required: itemInput.Required }}
                    defaultValue={itemInput.Value}
                    error={!!formState.errors[`${itemInput.Name}`]}
                    helperText={formState.errors[`${itemInput.Name}`]?.message}
                    required={itemInput.Required}
                  />
                  {/* } */}
                </>
              );
          }
        })}
      <Box
        sx={{
          width: "100%",
          marginTop: "0.5em",
        }}
      >
        <ReCAPTCHA
          className="iframeCaptcha"
          sitekey="6LeSrKEaAAAAAGnBnM94eRtpu1Z7PwnY3WpOyDvf"
          tabindex={100}
          onChange={props.clickSubmitCAPTCHA}
        />
      </Box>
      <Buttons
        disabledConfirm={!props.activeButton}
        onClickConfirm={handleSubmit(props.clickSubmit)}
        marginBottom={75}
        ConfirmButtonText="Registrarme"
      />
    </Box>
  );
};
